import Badge from "@/components/ui/badge";

import { formatToHumanReadable } from "@/lib/format-data";

import { PackageStatus } from "@/types/enums/package-status";

type SoldPackageStatusFields = {
  status: PackageStatus;
  expiresAt?: string | null;
};

/**
 * A sold package keeps its stored ACTIVE status after `expires_at` passes; the
 * API only refuses to redeem it. Treat it as expired so staff are not shown an
 * "Active" package they cannot use.
 */
export function isSoldPackageExpired(soldPackage: SoldPackageStatusFields) {
  return (
    soldPackage.status === PackageStatus.ACTIVE &&
    !!soldPackage.expiresAt &&
    new Date(soldPackage.expiresAt).getTime() < Date.now()
  );
}

const STATUS_VARIANT: Record<PackageStatus, "success" | "neutral" | "error"> = {
  [PackageStatus.ACTIVE]: "success",
  [PackageStatus.USED]: "neutral",
  [PackageStatus.CANCELLED]: "error",
};

export function SoldPackageStatusBadge({
  soldPackage,
  className,
}: {
  soldPackage: SoldPackageStatusFields;
  className?: string;
}) {
  if (isSoldPackageExpired(soldPackage)) {
    return (
      <Badge variant="warning" className={className}>
        Expired
      </Badge>
    );
  }
  return (
    <Badge
      variant={STATUS_VARIANT[soldPackage.status] ?? "default"}
      className={className}
    >
      {formatToHumanReadable(soldPackage.status)}
    </Badge>
  );
}
